module.exports = __webpack_public_path__ + "img/logo-colorfull-2x.f6502876.png";